import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"components/Logo.tsx\",\"import\":\"Syne\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"600\",\"700\"]}],\"variableName\":\"syne\"}");
